import { useEffect } from 'react';

const active = new Set<HTMLVideoElement>();

export function useActiveVideoManager(video: HTMLVideoElement | null) {
  useEffect(() => {
    if (!video) return;
    
    const onPlay = () => {
      active.forEach(v => v !== video && !v.paused && v.pause());
      active.add(video);
    };
    
    const onEnded = () => active.delete(video);
    const onPause = () => active.delete(video);

    video.addEventListener('play', onPlay);
    video.addEventListener('ended', onEnded);
    video.addEventListener('pause', onPause);
    
    return () => {
      video.removeEventListener('play', onPlay);
      video.removeEventListener('ended', onEnded);
      video.removeEventListener('pause', onPause);
      active.delete(video);
    };
  }, [video]);
}
